import React from 'react'
import { Slice } from 'gatsby'

const SingleSkuShopExplore = ({ data, isBlackFriday }) => {
  return (
    <Slice
        panelData={data}
        isBlackFriday={isBlackFriday}
        alias={`hover_panel`}
    />
  )
}

export default SingleSkuShopExplore
